import { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { db } from "./FireBase";
import { getDocs, collection } from "firebase/firestore";





function App() {

  const [portadaImg, setPortadaImg] = useState([]);


  useEffect(() => {

    const portadaImg = collection(db, "portada");
    const documentosPortada = getDocs(portadaImg);

    documentosPortada
      .then((res) => {

        const aux = [];

        res.forEach((documento) => {
          const imagen = {
            id: documento.id,
            ...documento.data()
          }
          aux.push(imagen);
        })
        setPortadaImg(aux)

      })
      .catch(() => {
        console.log("ERROR");
      })

  }, [])

  return (
    <div className="header">

          <div className="eee">
            {portadaImg ?
              <Carousel
                className="carousel"
                autoPlay={true}
                infiniteLoop={true}
                swipeable={true}
                showThumbs={false}
                showIndicators={false}
                showStatus={false}
                emulateTouch={true}
                autoFocus={true}
                dynamicHeight={false}
                showArrows={false}
                stopOnHover={true}
                interval={7000}
                transitionTime={1500}
                swipeScrollTolerance={5}
              >
                {
                  portadaImg.map((imagen, index) =>
                    <div key={index}>
                      <img src={imagen.img} />
                    </div>
                  )
                }

              </Carousel>
              :
              null
            }
          </div>
          <div className="brand-container">
            <div className="logo-tittle">
              <img className="logo" src="/img/logo.png" />
              <div>
                <h1>Sandwiches Roma</h1>
                <h2>No te quedes sin los tuyos!</h2>
              </div>
            </div>
            <div className="line"></div>
            <div className="icon-list">
              <a href="https://wa.me/5491137807560" target="_blank">
                <span style={{ color: "#2c3e50" }}>
                  <i className="fa-brands fa-whatsapp fa-3x" />
                </span>
              </a>
              <a href="https://www.instagram.com/sandwichesroma/" target="_blank">
                <span style={{ color: "#2c3e50" }}>
                  <i className="fa-brands fa-instagram fa-3x" />
                </span>
              </a>
              <a href="https://www.facebook.com/sandwichesromabera" target="_blank">
                <span style={{ color: "#2c3e50" }}>
                  <i className="fa-brands fa-facebook fa-3x" />
                </span>
              </a>
            </div>
          </div>
    


    </div>
  );
}

export default App;
